var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01677 7.59431C0.90328 7.41461 0.846535 7.32476 0.81477 7.18617C0.79091 7.08207 0.79091 6.91791 0.81477 6.81381C0.846535 6.67522 0.90328 6.58537 1.01677 6.40567C1.95461 4.92069 4.74617 1.16666 9.00034 1.16666C13.2545 1.16666 16.0461 4.92069 16.9839 6.40567C17.0974 6.58537 17.1541 6.67522 17.1859 6.81381C17.2098 6.91791 17.2098 7.08207 17.1859 7.18617C17.1541 7.32476 17.0974 7.41461 16.9839 7.5943C16.0461 9.07929 13.2545 12.8333 9.00034 12.8333C4.74617 12.8333 1.95461 9.07929 1.01677 7.59431Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00034 9.49999C10.381 9.49999 11.5003 8.3807 11.5003 6.99999C11.5003 5.61928 10.381 4.49999 9.00034 4.49999C7.61962 4.49999 6.50034 5.61928 6.50034 6.99999C6.50034 8.3807 7.61962 9.49999 9.00034 9.49999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSession);
export default __webpack_public_path__ + "static/media/viewSession.816f7d8b39301b273175d9cec7f1aacd.svg";
export { ForwardRef as ReactComponent };